import styled from 'styled-components';

export const UserVehicleDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  min-height: fit-content;
  width: 100%;
  padding: 36px;
`;
export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  height: fit-content;
  min-height: fit-content;
  width: 100%;

  font-weight: 600;
  color: ${(props) => props.theme.colors.gray[500]};
`;

export const VehicleInfoContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;

  padding: 24px;
  border-top: 1px solid ${(props) => props.theme.colors.gray[400]};

  div {
    display: flex;
    justify-content: space-between;
    width: 316px;

    p {
      margin: 0;
    }
  }
`;
export const DebtsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;

  padding: 24px;
  border-top: 1px solid ${(props) => props.theme.colors.gray[400]};

  h1 {
    font-size: 16px;
    line-height: 20px;
    font-weight: 700;
    height: fit-content;
    color: ${(props) => props.theme.colors.gray[900]};
  }

  header {
    align-items: center;
    display: flex;
    justify-content: space-between;
    
    div {
      align-items: center;
      display: flex;
      gap: 24px;
      span {
        display: flex;
        align-items: center;
        gap: 4px;
        width: fit-content;
        font-size: 16px;
  
        svg {
          margin: 0px 4px;
          height: 24px;
          width: 24px;
        }
      }
    }


    p {
      font-size: clamp(16px, 2vw, 20px);
      line-height: 20px;
      font-weight: 700;
      color: ${(props) => props.theme.colors.orange.primary};
    }
  }

  .totalValueLine {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 24px;
    width: 100%;
    border-top: 1px solid ${(props) => props.theme.colors.gray[400]};
    padding-top: 24px;
    h1 {
      font-size: clamp(16px, 2vw, 18px);
      line-height: 20px;
      font-weight: 700;
      color: ${(props) => props.theme.colors.gray[900]};
    }
  }

  section {
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 100%;
    font-size: 16px;

    > aside {
      cursor: default;
      display: flex;
      justify-content: space-between;
      width: 100%;

      span {
        cursor: pointer;
        display: flex;
        align-items: center;
        gap: 8px;
        width: fit-content;

        svg {
          color: ${(props) => props.theme.colors.orange.primary};
          height: 28px;
          width: 28px;
        }
      }
    }

    div {
      margin-left: 36px;
      aside {
        cursor: default;
        width: 100%;
        
        span {
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 8px;
          width: 100%;

          svg {
            color: ${(props) => props.theme.colors.orange.primary};
            height: 28px;
            width: 28px;
          }
        }
      }
      article {
        display: flex;
        flex-direction: column;
        gap: 8px;
        padding: 16px 0px;

        .multasDescription {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          grid-gap: 15px;

          .description {
            max-width: 400px;
            p {
              font-weight: 700;
            }
          }
        }

        span {
          font-weight: 300;
        }

        button {
          width: 304px;
          min-height: 48px;
          align-self: self-end;
        }
      }
    }
  }

  .payButton {
    display: flex;
    justify-content: flex-end;
  }
`;

export const OrdersContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
  height: fit-content;
  max-height: 416px;

  overflow-y: scroll;

  padding: 24px;

  padding: 24px;
  border-top: 1px solid ${(props) => props.theme.colors.gray[400]};

  > div {
    display: flex;
    justify-content: space-between;
    background-color: ${(props) => props.theme.colors.gray[200]};
    border-radius: 12px;
    padding: 8px 24px 20px 24px;

    span {
      display: flex;
      flex-direction: column;
      font-size: 16px;
      font-weight: 400;
      color: ${(props) => props.theme.colors.gray[600]};

      h3 {
        font-size: 16px;
        font-weight: 700;
        color: ${(props) => props.theme.colors.orange.primary};
        margin: 8px 0px;
        width: fit-content;
      }
      h4 {
        color: ${(props) => props.theme.colors.blue.pressing};
        border-bottom: 1px solid ${(props) => props.theme.colors.blue.pressing};
        font-size: 16px;
        font-weight: 400;
        width: fit-content;
        white-space: pre-line;
      }
      h5 {
        font-weight: 500;
        width: fit-content;
        white-space: pre-wrap;
        font-size: 16px;

        cursor: pointer;

        strong {
          color: ${(props) => props.theme.colors.gray[500]};
          font-weight: 600;
        }
      }
    }
  }
`;

export const TitleToConsultWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 24px;

  box-shadow: ${(props) => props.theme.shadow.default};
  border-radius: 12px;
  padding: 24px;

  aside {
    span {
      display: flex;
      gap: 16px;
    }
    h2 {
      font-size: 16px;
      line-height: 20px;
      font-weight: 700;
      color: ${(props) => props.theme.colors.gray[900]};
      margin: 0;
      white-space: nowrap;
    }
    p {
      font-size: 14px;
      font-weight: 500;
      color: ${(props) => props.theme.colors.gray[500]};
      margin: 0;

      strong {
        color: ${(props) => props.theme.colors.gray[900]};
      }
    }

    p {
      font-size: 14px;
      font-weight: 500;
      color: ${(props) => props.theme.colors.gray[500]};
      margin: 0;

      strong {
        color: ${(props) => props.theme.colors.gray[900]};
      }
    }
  }

  button {
    max-width: fit-content;
  }
`;
